/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CSSProperties } from "react";

import { Animate, Wrap } from "@components/elements";
import { CosmosStackProps } from "@components/types";
import { css, cx } from "@panda/css";
import { Stack } from "@panda/jsx";
import { token } from "@panda/tokens";

import { CosmosDesc } from "./";

import type { CosmosVariableRichText } from "@components/elements";
import { ColorfulTitle } from "./ColorfulTitle.molecule";
import { CosmosEnumEdsGradients } from "@cosmos/hygraph-schema";

export interface TitleDescStackProps {
	animate?: boolean;
	description?: CosmosVariableRichText | null;
	stack?: CosmosStackProps;
	title?: CosmosVariableRichText | null;
	gradient?: CosmosEnumEdsGradients | null;
	className?: string;
}

interface CssVariables extends CSSProperties {
	"--gap"?: string;
}

export const TitleDescStack = ({
	animate = false,
	className,
	description,
	stack,
	title,
	gradient,
}: TitleDescStackProps): React.JSX.Element | null => {
	const spacingToken = stack?.gap ? token(`spacing.${stack?.gap}`) : token("spacing.eds.dimension.16");
	const style: CssVariables = { "--gap": spacingToken };

	if (!title?.text && !description?.text && !description?.html) return null;

	return (
		<Stack
			{...stack}
			className={cx(
				`title-desc-stack`,
				css({
					gap: "var(--gap)",
				}),
				className,
			)}
			justify={stack?.justify || "start"}
			style={style}
		>
			{title?.text ? (
				<Wrap
					condition={animate}
					wrap={(children) => (
						<Animate delay={0.05} type="slide">
							{children}
						</Animate>
					)}
				>
					<ColorfulTitle gradient={gradient} title={title} />
				</Wrap>
			) : (
				""
			)}
			{description?.html ? (
				<Wrap
					condition={animate}
					wrap={(children) => (
						<Animate delay={0.15} type="slide">
							{children}
						</Animate>
					)}
				>
					<CosmosDesc description={description} />
				</Wrap>
			) : (
				""
			)}
		</Stack>
	);
};
